export const TRAVEL_DS_THEME_CLASS = 'travel-theme-v2';
